import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import { setLoadTreatmentToQueue } from '../app-context/caller';
import { DeleteOutlined } from '@ant-design/icons';


interface Props {
    incomingCallDetailsQueue: Function;
}

const ListOfCalls = (props: Props) => {

    const [showIcon, setShowIcone] = useState(false);
    const [openListOfCalls, setOpenListOfCalls] = React.useState(false);

    const [callList, setCallList] = useState([]);

    const dispatch = useDispatch();

    const loadTreatmentToQueue = useSelector((state: RootState) => state.call.loadTreatmentToQueue);

    // const value = useSelector((state: RootState) => state.user.value);

    useEffect(() => {
        const loggerUser = localStorage.getItem('loggedUser');
        if (loggerUser) {
            const parsedUser = JSON.parse(loggerUser);
            if (parsedUser && parsedUser) {
                setShowIcone(true);
            }
        }
    }, [])

    useEffect(() => {
        const treatmentQueue = localStorage.getItem('treatmentQueue');
        if (treatmentQueue && treatmentQueue !== '[]') {
            const parsedQueue = JSON.parse(treatmentQueue);
            setCallList(parsedQueue);
            dispatch(setLoadTreatmentToQueue({ load: false })); // Reset the flag after loading

        }
        else {
            setCallList([]);
        }
    }, [loadTreatmentToQueue]);

    // when logout is clicked, clear the treatmentQueue
    // useEffect(() => {
    //     console.log('useEffect-logout event')
    //     if(!value) {
    //         console.log('useEffect-logout inside')

    //         localStorage.removeItem('treatmentQueue');
    //         setCallList([]);
    //     }
    // }, [value == false]);



    return (
        <>

            <div className="list-of-calls-icon-warper">
                <div className="call-icon" onClick={() => setOpenListOfCalls(!openListOfCalls)}></div>
                {callList.length > 0 && <span className="call-badge">{callList.length}</span>}
            </div>

            {/* Render the list of calls if openListOfCalls is true */}

            {openListOfCalls && (
                <div className="calls-popup">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <button className="close-button" onClick={() => setOpenListOfCalls(false)}>X</button>
                        <p>שיחות שלא שוייכו</p>
                    </div>
                    <ul className="calls-list">

                        {callList.map((call: any) => (
                            <li key={call.Id} className="call-item">
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {/* create icon of delete */}

                                        <div style={{
                                            fontSize: '20px',
                                            marginLeft: '10px',
                                            color: 'red',
                                            cursor: 'pointer'
                                        }} onClick={() => {
                                            const updatedList = callList.filter((c: any) => c.Id !== call.Id);
                                            setCallList(updatedList);
                                            localStorage.setItem('treatmentQueue', JSON.stringify(updatedList));
                                        }}>X</div>

                                        <button className="call-list-button" onClick={() => props.incomingCallDetailsQueue(call, call.TypeEndOfCall, call.MessageEndOfCall)}>שיוך</button>
                                    </div>
                                    <span className="call-time">{call.From.length > 8 ? call.From : call.To}</span>
                                </div>
                                <span className="call-time">{call.CreatedDate}</span>

                            </li>
                        ))}
                    </ul>
                </div>
            )}

        </>
    )
}

export default ListOfCalls